// "use client";

// import { useEffect } from "react";
// import { useAllPageDetail, useAllPageSave } from "../../../hooks/api/allPages/hooks";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useForm, Controller } from "react-hook-form";
// import * as yup from "yup";
// import toast from "react-hot-toast";
// import { Form, Input, Button } from "antd";
// import UploadFoodImage from "../../../lib/UploadFoodImage";
// import { TPageType } from "@src/types/api/allPages";

// // ---------------- Validation ----------------
// const schema = yup.object({
//   heading: yup.string().required("Heading is required"),
//   image: yup.string().required("Image is required"),
// });

// type PageFormType = yup.InferType<typeof schema>;


// const PagesForm = ({ pageType }: {pageType: TPageType }) => {

//   // ---------------- Fetch Page Detail ----------------
//   const { data: details, refetch } = useAllPageDetail(pageType);

//   // ---------------- Save Page ----------------
//   const { mutate: savePage, isPending } = useAllPageSave({
//     onSuccess: () => {
//       toast.success("Saved successfully");
//       refetch();
//     },
//     onError: (error: any) =>
//       toast.error(error?.message || "Something went wrong"),
//   });

//   const { control, handleSubmit, reset } = useForm<PageFormType>({
//     resolver: yupResolver(schema),
//     defaultValues: {
//       heading: "",
//       image: "",
//     },
//   });

//   // ---------------- Prefill Data ----------------
//   useEffect(() => {
//     if (details?.data) {
//       reset({
//         heading: details.data.banner.heading || "",
//         image: details.data.banner.image || "",
//       });
//     } else {
//       reset({
//         heading: "",
//         image: "",
//       });
//     }
//   }, [details, pageType, reset]);

//   // ---------------- Submit ----------------
//   const onSubmit = (values: PageFormType) => {

//     savePage({
//       ...(details?.data?._id && { _id: details.data._id }),

//       pageType: pageType,

//       banner: {
//         heading: values.heading,
//         image: values.image,
//       },
//     });
//   };

//   return (
//     <div className="w-full mx-auto p-6 bg-[#fdf0e3] rounded-xl border border-blue-300">

//       <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>

//         {/* HEADING */}
//         <Form.Item label="Heading" required>
//           <Controller
//             name="heading"
//             control={control}
//             render={({ field }) => (
//               <Input {...field} placeholder="Enter heading" />
//             )}
//           />
//         </Form.Item>

//         {/* IMAGE */}
//         <Form.Item label="Image" required>
//           <Controller
//             name="image"
//             control={control}
//             render={({ field }) => (
//               <UploadFoodImage
//                 maxUploadCount={1}
//                 value={field.value}
//                 onChange={(files) => field.onChange(files)}
//               />
//             )}
//           />
//         </Form.Item>

//         {/* BUTTON */}
//         <div className="mt-6 flex justify-start">
//           <Button
//             type="primary"
//             htmlType="submit"
//             loading={isPending}
//             className="bg-orange-500 hover:bg-orange-600"
//           >
//             {isPending ? "Saving..." : "Save"}
//           </Button>
//         </div>

//       </Form>

//     </div>
//   );
// };

// export default PagesForm;

"use client";

import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { Form, Input, Button } from "antd";

import UploadFoodImage from "../../../lib/UploadFoodImage";
import { IPageBannerPayload } from "@src/types/api/pageBanner";
import { PageType } from "@src/types/api/pageBanner";
import { usePageBannerDetail, usePageBannerSave } from "../../../hooks/api/page-banner/hooks";

// ---------------- Validation ----------------
const schema = yup.object({
  heading: yup.string().required("Heading is required"),
  image: yup.string().required("Image is required"),
});

type PageFormType = yup.InferType<typeof schema>;

interface PagesFormProps {
  pageType: PageType;
}

const PagesForm = ({ pageType }: PagesFormProps) => {
  // ---------------- Fetch Page Detail ----------------
  const { data: details, refetch } = usePageBannerDetail(pageType);

  // ---------------- Save Page Banner ----------------
  const { mutate: savePage, isPending: isLoading } = usePageBannerSave({
    onSuccess: () => {
      toast.success("Saved successfully");
      refetch();
    },
    onError: (error: any) => toast.error(error?.message || "Something went wrong"),
  });

  // ---------------- Form Setup ----------------
  const { control, handleSubmit, reset } = useForm<PageFormType>({
    resolver: yupResolver(schema),
    defaultValues: { heading: "", image: "" },
  });

  // ---------------- Prefill Data ----------------
  useEffect(() => {
    if (details?.data?.banner) {
      reset({
        heading: details.data.banner.heading || "",
        image: details.data.banner.image || "",
      });
    } else {
      reset({ heading: "", image: "" });
    }
  }, [details, pageType, reset]);

  // ---------------- Submit ----------------
  const onSubmit = (values: PageFormType) => {
    const payload: IPageBannerPayload = {
      pageType,
      banner: {
        heading: values.heading,
        image: values.image,
      },
      ...((details?.data?._id && { _id: details.data._id }) || {}),
    };

    savePage(payload);
  };

  return (
    <div className="w-full mx-auto p-6 bg-[#fdf0e3] rounded-xl border border-blue-300">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        {/* HEADING */}
        <Form.Item label="Heading" required>
          <Controller
            name="heading"
            control={control}
            render={({ field }) => <Input {...field} placeholder="Enter heading" />}
          />
        </Form.Item>

        {/* IMAGE */}
        <Form.Item label="Image" required>
          <Controller
            name="image"
            control={control}
            render={({ field }) => (
              <UploadFoodImage
                maxUploadCount={1}
                value={field.value}
                onChange={(files) => field.onChange(files)}
              />
            )}
          />
        </Form.Item>

        {/* BUTTON */}
        <div className="mt-6 flex justify-start">
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            className="bg-orange-500 hover:bg-orange-600"
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default PagesForm;